import { contentFor } from '../../docs/content.ts'
import { Markdown } from '../../docs/Markdown.tsx'
import './docs.css'

// The API Terms of Use, at `/terms`.
//
// Kept at the same path it had on docs.curri.com because it is named in a
// *published* OpenAPI document (`apps/curri-api/openapi/v1-routing.yaml`), which
// partners have already downloaded. That makes the path part of a shipped
// contract rather than a routing choice.
//
// No page tree and no contents panel: it is one long legal document, and both
// would frame it as part of the API reference rather than as terms.

export const Terms = ({
  onNavigate,
}: {
  onNavigate: (path: string) => void
}) => (
  <div className="curri-docs">
    <div className="curri-docs__main">
      <article className="curri-docs__article">
        <Markdown
          markdown={contentFor('terms.md')}
          onNavigate={onNavigate}
          pagePath="/terms"
        />
      </article>
    </div>
  </div>
)
